import { deliveriesToday, type ShipmentItem } from "@/mocks/managerWorkspace";

export default function DeliveriesWidget() {
  return (
    <div className="bg-white rounded-lg border border-[#D5CA8A] overflow-hidden h-full flex flex-col">
      <div className="flex items-center justify-between px-3 py-2 bg-[#D4EDDA] border-b border-[#D5CA8A]">
        <div className="flex items-center gap-1.5">
          <i className="ri-truck-line text-[12px] text-[#2D6A4F]"></i>
          <span className="text-[11px] font-semibold text-[#2D6A4F]">Доставки сегодня</span>
        </div>
        <span className="text-[11px] font-bold text-[#2D6A4F]">{deliveriesToday.length}</span>
      </div>
      <div className="flex-1 overflow-auto">
        <table className="w-full text-[10px]">
          <thead>
            <tr className="bg-[#D4EDDA]/50 text-[#2D6A4F]">
              <th className="text-left px-2 py-1 font-medium">Клиент</th>
              <th className="text-left px-2 py-1 font-medium">Документ</th>
              <th className="text-left px-2 py-1 font-medium">Дата доставки</th>
              <th className="text-left px-2 py-1 font-medium">Статус</th>
            </tr>
          </thead>
          <tbody>
            {deliveriesToday.map((s: ShipmentItem, i: number) => (
              <tr key={i} className="border-b border-[#D5CA8A]/30 hover:bg-[#D4EDDA]/30 transition-colors">
                <td className="px-2 py-1.5 text-[#2D2D2D]">{s.client}</td>
                <td className="px-2 py-1.5 text-[#666666]">{s.document}</td>
                <td className="px-2 py-1.5 text-[#666666]">{s.date}</td>
                <td className="px-2 py-1.5">
                  <span className={`px-1.5 py-0.5 rounded text-[9px] font-medium ${s.statusColor}`}>{s.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-3 py-1.5 border-t border-[#D5CA8A]">
        <button className="text-[10px] text-[#2D2D2D] hover:bg-[#D4EDDA] px-2 py-0.5 rounded transition-colors cursor-pointer whitespace-nowrap">
          Все доставки
        </button>
      </div>
    </div>
  );
}